import { Link } from 'react-router-dom';
import { articles } from '@/mocks/articles';
import { categories } from '@/mocks/categories';

export default function LatestPostsSection() {
  const latestPosts = articles
    .filter((a) => !a.isHot || a.id > 15)
    .sort((a, b) => new Date(b.publishDate).getTime() - new Date(a.publishDate).getTime())
    .slice(0, 8);

  return (
    <section className="w-full px-4 md:px-6 py-16 md:py-20 bg-background-100">
      <div className="max-w-7xl mx-auto">
        <div className="flex items-center justify-between mb-10">
          <div>
            <h2 className="font-heading text-2xl md:text-3xl font-bold text-foreground-950 mb-2">
              最新分享
            </h2>
            <p className="text-sm text-foreground-500">社区最新发布的内容</p>
          </div>
          <Link
            to="/category"
            className="hidden sm:flex items-center gap-1 text-sm text-primary-500 hover:text-primary-600 transition-colors duration-200 whitespace-nowrap"
          >
            查看全部
            <div className="w-4 h-4 flex items-center justify-center">
              <i className="ri-arrow-right-line text-xs"></i>
            </div>
          </Link>
        </div>

        <div className="bg-background-50 rounded-lg border border-background-200/70 divide-y divide-background-100">
          {latestPosts.map((post) => {
            const catInfo = categories.find((c) => c.slug === post.category);
            return (
              <Link
                key={post.id}
                to={`/article/${post.id}`}
                className="flex items-center gap-4 p-4 hover:bg-background-50/70 transition-colors duration-200 cursor-pointer group"
              >
                <div className="flex-shrink-0 w-8 h-8 flex items-center justify-center rounded-full bg-secondary-100">
                  <span className="text-xs font-medium text-secondary-600">
                    {catInfo?.name?.charAt(0) || '帖'}
                  </span>
                </div>
                <div className="flex-1 min-w-0">
                  <h3 className="text-sm font-medium text-foreground-900 truncate group-hover:text-primary-500 transition-colors duration-200">
                    {post.title}
                  </h3>
                  <div className="flex items-center gap-3 mt-1 text-xs text-foreground-400">
                    <span>{catInfo?.name}</span>
                    <span>{post.author}</span>
                    <span>{post.publishDate}</span>
                  </div>
                </div>
                <div className="flex-shrink-0 flex items-center gap-3 text-xs text-foreground-400">
                  <span className="flex items-center gap-1">
                    <div className="w-3 h-3 flex items-center justify-center">
                      <i className="ri-eye-line text-[10px]"></i>
                    </div>
                    {(post.views / 1000).toFixed(1)}k
                  </span>
                  <span className="flex items-center gap-1">
                    <div className="w-3 h-3 flex items-center justify-center">
                      <i className="ri-chat-3-line text-[10px]"></i>
                    </div>
                    {post.replies}
                  </span>
                </div>
              </Link>
            );
          })}
        </div>
      </div>
    </section>
  );
}